module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"text-encoding","commonjs2":"text-encoding","amd":"text-encoding","root":"text-encoding"}
// module id = 37
// module chunks = 0